import React from 'react';

import styled from 'styled-components';

import GroupsFilters from './filters/GroupsFilters';
import GroupsActions from './GroupsActions';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const GroupsControls = () => {
  return (
    <Container>
      <GroupsFilters />
      <GroupsActions />
    </Container>
  );
};

export default GroupsControls;
